// Public organization facts for site identity and legal pages.
// Do not invent SAM.gov / UEI values - publish only after real registration.

export const LEGAL_NAME = 'Elm Business Solutions';
export const SHORT_NAME = 'EBS';
export const WEBSITE_URL = 'https://elmbsol.com';
export const SERVICE_AREA = 'United States';

// Public mailing address (ZIP completed to Middletown CT 06457 from provided 0645).
export const MAILING_ADDRESS = '515 CenterPoint Drive, Suite 707\nMiddletown, CT 06457';

// Set only after SAM.gov registration is complete. Example: 'ABCD1EF2GH3'.
export const SAM_UEI = null;
